import { DataTable } from '@/components/ui/DataTable';
import { Badge } from '@/components/ui/Badge';
import type { AdminDomain } from '@/types/admin.types';
import { formatDateTime, formatRelativeTime } from '@/utils/formatters';
import { createColumnHelper } from '@tanstack/react-table';
import { useNavigate } from 'react-router-dom';

const columnHelper = createColumnHelper<AdminDomain>();

const columns = [
  columnHelper.accessor('name', {
    header: 'Domaine',
    cell: (info) => <p className="font-medium text-neutral-900 dark:text-neutral-200">{info.getValue()}</p>,
  }),
  columnHelper.accessor('organisationName', {
    header: 'Organisation',
    cell: (info) => <span className="text-neutral-600 dark:text-neutral-400">{info.getValue()}</span>,
  }),
  columnHelper.accessor('folderCount', {
    header: 'Dossiers',
    cell: (info) => <span className="text-neutral-600 dark:text-neutral-400">{info.getValue()}</span>,
  }),
  columnHelper.accessor('lastSyncStatus', {
    header: 'Sync',
    cell: (info) => {
      const v = info.getValue();
      return <Badge variant={v === 'success' ? 'success' : v === 'error' ? 'danger' : 'neutral'}>{v || 'N/A'}</Badge>;
    },
  }),
  columnHelper.accessor('lastSyncAt', {
    header: 'Dernière sync',
    cell: (info) => <span className="text-xs text-neutral-500">{info.getValue() ? formatRelativeTime(info.getValue()) : 'Jamais'}</span>,
  }),
  columnHelper.accessor('createdAt', {
    header: 'Création',
    cell: (info) => <span className="text-xs text-neutral-500">{formatDateTime(info.getValue())}</span>,
  }),
];

interface DomainsTableProps {
  data: AdminDomain[];
  loading?: boolean;
}

export function DomainsTable({ data, loading }: DomainsTableProps) {
  const navigate = useNavigate();
  return (
    <DataTable columns={columns} data={data} loading={loading} onRowClick={(row) => navigate(`/domains/${row.uuid}`)} emptyMessage="Aucun domaine trouvé" />
  );
}
